import PriceRowMarginText from '../PriceRowMarginText'
import { connect } from 'react-redux'
import useSurchargeMargin from 'hooks/Offers/useSurchargeMarginFetcher'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'

interface MappedProps {
  canViewLuxPlusBenefits: boolean
  showMarginInSpoofMode: boolean
}

interface Props {
  checkIn: string | undefined
  pkg: App.Package
  type: 'exact' | 'estimate'
}

function FlashHotelMarginText(props: Props & MappedProps) {
  const {
    canViewLuxPlusBenefits,
    checkIn,
    pkg,
    showMarginInSpoofMode,
    type,
  } = props

  const { surchargeMargin } = useSurchargeMargin({ checkIn, duration: pkg.duration, roomRateId: (pkg.roomRate?.id) })

  const surchargeMarginAud = surchargeMargin?.status === 'success' ? surchargeMargin.marginAud : 0
  // the price difference between lux plus and non lux plus comes directly out of margin
  const marginToRemoveIfOnLuxPlus = canViewLuxPlusBenefits ? pkg.price - pkg.memberPrice : 0

  const marginValue = Number.isFinite(pkg.marginAud) ?
      (pkg.marginAud ?? 0) - marginToRemoveIfOnLuxPlus :
    0

  return <>
    {showMarginInSpoofMode && <PriceRowMarginText
      type={type}
      marginValue={marginValue + surchargeMarginAud}
    />}
  </>
}

const mapStateToProps = (state: App.State) => ({
  showMarginInSpoofMode: state.system.showMarginInSpoofMode,
  canViewLuxPlusBenefits: getCanViewLuxPlusBenefits(state),
})

export default connect(mapStateToProps)(FlashHotelMarginText)
